module.exports = __webpack_public_path__ + "img/certi.a488f1d8.svg";